import { Spacer } from "Components/Common/Spacer/index";
import {
  TypographyT32,
  TypographyT7,
} from "Components/Common/Typography/index";
import { PageWrapperT1 } from "Components/Common/Wrapper/PageWrapper";
import {
  FilterBox,
  FreightDetails,
  FreightInformationCard,
  RateComparisonTable,
} from "Components/RateComparison/MultimodalRateComparison​/index";
import React, { Component, Fragment } from "react";
import { BackButtonT1, IconButtonT1 } from "Components/Common/Button/index";
import BasicDetails from "Components/RateComparison/CalculationForFreight/BasicDetails";
import FreightCalculationInfo from "Components/RateComparison/CalculationForFreight/FreightCalculationInfo";
import HeaderInfoDetails from "Components/RateComparison/CalculationForFreight/HeaderInfoDetails";
import Rupees from "Components/RateComparison/CalculationForFreight/Rupees";
import RFQInformationTable from "Components/RateComparison/CalculationForFreight/RFQInformationTable";
import ViewDetailsAccordion from "Components/RateComparison/MultimodalRateComparison​/ViewDetailsAccordion";
import ModalT1 from "Components/Common/Modal/ModalT1";
import { ModalCardT1 } from "Components/RateComparison/CalculationForFreight/index";
import { ReactComponent as ArrowOutline } from "Icons/ArrowOutline.svg";
class ACCForRateComparison extends Component {
  render() {
    return (
      <Fragment>
        <PageWrapperT1>
          <TypographyT7>ACCForRateComparison</TypographyT7>
          <Spacer spacing={"20px"} />
          <BackButtonT1 />

          <Spacer spacing={"20px"} />
          <ModalT1 isOpenState={false}>
            <ModalCardT1 title={"Average Calculation for Hazira To Lucknow"}>
              <RFQInformationTable />
            </ModalCardT1>
          </ModalT1>
          <Spacer spacing={"20px"} />
          <ViewDetailsAccordion />
          <Spacer spacing={"20px"} />
          <FreightDetails />
          <Spacer spacing={"20px"} />
          <TypographyT32>
            Alwar - Alwar Yard - Mohanlal Ganj - Lucknow
          </TypographyT32>
          <Spacer spacing={"20px"} />
          <RFQInformationTable />
          <Spacer spacing={"20px"} />
          <HeaderInfoDetails
            rate={<Rupees rate={"4217"} />}
            variationRate={"-804"}
          />
          <Spacer spacing={"20px"} />
          <FreightCalculationInfo />
          <Spacer spacing={"20px"} />
          <BasicDetails />
          <Spacer spacing={"20px"} />
          <RateComparisonTable />
          <Spacer spacing={"20px"} />
          <IconButtonT1>
            <ArrowOutline
              fill={"#6F7C8C"}
              width={"24px"}
              transform="rotate(180)"
            />
          </IconButtonT1>
          <Spacer spacing={"20px"} />
          <IconButtonT1>
            <ArrowOutline fill={"#528AEA"} width={"24px"} />
          </IconButtonT1>
          <Spacer spacing={"20px"} />
          <FreightInformationCard />
          <Spacer spacing={"20px"} />
          <FilterBox />
          <Spacer spacing={"20px"} />
        </PageWrapperT1>
      </Fragment>
    );
  }
}

export default ACCForRateComparison;
